import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeContext, useThemeLogic } from './hooks/useTheme';
import HomePage from './pages/HomePage';
import CareerCLIPage from './pages/CareerCLIPage';
import CookieConsent from './components/ui/CookieConsent';

const AnalyticsPage = lazy(() => import('./pages/AnalyticsPage'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  const themeLogic = useThemeLogic();

  const handleCookieAccept = () => {
    // Analytics will be enabled
    console.log('Analytics cookies accepted');
  };

  const handleCookieReject = () => {
    // Analytics will be disabled
    console.log('Analytics cookies rejected');
  };

  const handleCookieCustomize = () => {
    // User is customizing preferences
    console.log('Cookie preferences customization opened');
  };

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeContext.Provider value={themeLogic}>
        <Router>
          <Routes>
            {/* / is the new Career CLI; /classic preserves the original GUI. */}
            <Route path="/" element={<CareerCLIPage />} />
            <Route path="/classic" element={<HomePage />} />
            <Route path="/analytics" element={<Suspense fallback={<div className="min-h-screen" />}><AnalyticsPage /></Suspense>} />
            <Route path="/privacy" element={<Suspense fallback={<div className="min-h-screen" />}><PrivacyPolicy /></Suspense>} />
          </Routes>
          
          {/* Cookie Consent Banner */}
          <CookieConsent
            onAccept={handleCookieAccept}
            onReject={handleCookieReject}
            onCustomize={handleCookieCustomize}
          />
        </Router>
      </ThemeContext.Provider>
    </QueryClientProvider>
  );
}

export default App;